export default __webpack_public_path__ + "static/media/Scientist.381d77d9.png";